module.exports = __webpack_public_path__ + "static/media/fourInnerImg3.556be410.png";